import React from "react";
import glamorous from "glamorous";

import Pin from "react-icons/lib/md/location-on"

export const AddressOverlayPanel = props => {
  const { location, pinColor } = props;

  let addressLine1 = "";
  let addressLine2 = "";
  if (location && location.address.length > 0) {
    addressLine1 = location.address;

    addressLine2 =
      location.city + " " + location.state + " " + location.postal_code;
  }

  return (
    <glamorous.Div
      paddingLeft={10}
      paddingRight={10}
      paddingTop={10}
      paddingBottom={25}
      left={0}
      top={0}
      right={0}
      fontSize="small"
      position="absolute"
      color="white"
      background="linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0))"
      flexDirection="row"
      display="flex"
      alignItems="center"
    >
      <Pin color={pinColor} size={30}/>
      <glamorous.Div css={{flexDirection: 'column', paddingLeft: 5}}>
        {addressLine1}
        <br />
        {addressLine2}
      </glamorous.Div>
    </glamorous.Div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/map/OverlayPanel.js